import { faEllipsisVertical, faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { delActu } from "../actions/actus";
import { connect } from "react-redux";
import { tempAlWait } from "../helpers";

class AdminItemActu extends React.Component {
    state = {
        optActive: false
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redDelActu != this.props.redDelActu) {
            this.props.changeAlert(this.props.redDelActu.alert);

            if (this.props.redDelActu.isNext) {
                this.props.refreshList(true);
            }
        }
    }

    handleDelete(id) {
        if (window.confirm("Souhaitez-vous réellement supprimer cette actualité ?")) {
            this.props.changeAlert(tempAlWait());
            this.props.delActu({actuId: id});
        }
    }

    render() {
        return <li className="admin__item">
            {/** Id **/}
            <span className="admin__item__id">{this.props.data.id}</span>

            {/** Titre **/}
            <span className="admin__item__ttl">{this.props.data.title}</span>

            {/** Options **/}
            <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                {/** Voir **/}
                <Link
                    title="Voir l'actualité"
                    aria-label="Voir l'actualité"
                    className="admin__item__optbtn"
                    to={`/article/${this.props.data.id}`}
                    target="_blank"
                >
                    <FontAwesomeIcon icon={faEye} />
                </Link>

                {/** Modifier **/}
                <Link
                    title="Modifier l'actualité"
                    aria-label="Modifier l'actualité"
                    className="admin__item__optbtn"
                    to={`/admin/actus/edit/${this.props.data.id}`}
                >
                    <FontAwesomeIcon icon={faPen} />
                </Link>

                {/** Supprimer **/}
                <button
                    title="Supprimer l'actualité"
                    aria-label="Supprimer l'actualité"
                    className="admin__item__optbtn admin__item__optbtn--del"
                    onClick={() => this.handleDelete(this.props.data.id)}
                >
                    <FontAwesomeIcon icon={faTrashCan} />
                </button>
            </div>

            {/** Options bouton **/}
            <button
                title={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                aria-label={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                className="admin__item__btnopt"
                onClick={() => this.setState({optActive: !this.state.optActive})}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
        </li>
    }
}

const mapStateToProps = state => {
    return {
        redDelActu: state.redDelActu
    }
}

const mapDispatchToProps = {
    delActu
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminItemActu);